// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1fdIC","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2tf5h"};